import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { DatePicker } from '..';
import { IDatePickerProps } from '.';
import SvgIcon from '../SvgIcon';

export interface InputDatePickerProps extends IDatePickerProps {}

/**
 * GIK Input component with a datepicker
 */
export function InputDatePicker({ className, ...otherProps }: InputDatePickerProps): React.ReactElement {
  const bem = bemBlock(`input-datepicker`);
  return (
    <div className={bem(null, null, className)}>
      <DatePicker {...otherProps} />
      <SvgIcon className={bem('icon')} name="CalendarOutline" />
    </div>
  );
}
